// src/components/IncomingOrders/helpers/addressUtils.js

const addressObjectMap = Object.freeze({
  delivery: "deliveryAddress",
  invoice: "invoiceAddress",
  orderer: "ordererAddress",
});

export const ADDRESS_FIELDS = [
  "customerId",
  "address1",
  "address2",
  "address3",
  "address4",
  "address5",
  "city",
  "zip",
  "country",
  "reference",
  "email",
  "telephone",
  "contact",
];

const validAddressFields = new Set(ADDRESS_FIELDS);

const handleError = (message) => {
  const isDevLike = process.env.NODE_ENV !== "production";

  if (isDevLike) {
    throw new Error(message);
  } else {
    console.error(message);
    return null;
  }
};

const getBasePath = (editType) => {
  const basePath = addressObjectMap[editType];

  if (!basePath) {
    handleError(`Invalid editType: "${String(editType)}". Valid types: ${Object.keys(addressObjectMap).join(", ")}`);
    return null;
  }

  return basePath;
};

export const hasStringValue = (value) => {
  if (typeof value !== "string") return false;
  return value.trim().length > 0;
}

export const getAddressObjectName = (editType) => {
  return getBasePath(editType);
};

export const createAddressFieldPath = (editType, field) => {
  const basePath = getBasePath(editType);

  if (basePath == null) return null;

  if (!validAddressFields.has(field)) {
    handleError(`Invalid address field: "${String(field)}"`);
    return null;
  }

  return `${basePath}.${field}`;
};

export function normalizeAddress(addr) {
  if (!addr) return {};

  const clean = {};

  Object.entries(addr).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (key.startsWith("__")) return;
    clean[key] = value;
  });

  return clean;
};
